jQuery(document).ready(function ($) {

  // Responsive Background Image Swapper
  function responsiveBg() {
    $('.resp-bg').each(function () {
      const $this = $(this);
      const desktopImg = $this.data('desktop-img');
      const mobileImg = $this.data('mobile-img');

      if (window.innerWidth < 768) {
        $this.css('background-image', `url(${mobileImg})`);
      } else {
        $this.css('background-image', `url(${desktopImg})`);
      }
    });
  }

  responsiveBg();
  
  // Debounced resize handler
  let resizeTimeout;
  $(window).resize(function() {
    if (resizeTimeout) {
      clearTimeout(resizeTimeout);
    }
    resizeTimeout = setTimeout(responsiveBg, 100);
  });

  // Initialize Swiper only if it's loaded and elements exist
  function initSwipers() {
    if (typeof Swiper === 'undefined') return;
    
    // Swiper Block Logos
    if ($('.swiper-block-logos').length > 0) {
      const swiperBlockLogos = new Swiper('.swiper-block-logos', {
        spaceBetween: 46,
        speed: 3000,
        direction: 'horizontal',
        autoplay: {
          delay: 0,
          disableOnInteraction: false
        },
        loop: true,
        slidesPerView: 1,
        freeMode: true,
        breakpoints: {
          320: {
            slidesPerView: 2,
          },
          568: {
            slidesPerView: 3,
          },
          768: {
            slidesPerView: 4,
          },
          1024: {
            slidesPerView: 5,
          },
          1200: {
            slidesPerView: 6,
          },
          1500: {
            slidesPerView: 7,
          }
        }
      });
    }

    // Swiper Block Case Studies
    if ($('.swiper-block-case-studies').length > 0) {
      const swiperBlockCaseStudies = new Swiper('.swiper-block-case-studies', {
        spaceBetween: 20,
        speed: 800,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        },
        centeredSlides: true,
        loop: true,
        slidesPerView: 1,
        slidesPerGroup: 1,
        navigation: {
          nextEl: '.swiper-block-case-studies .swiper-button-next',
          prevEl: '.swiper-block-case-studies .swiper-button-prev',
        },
        breakpoints: {
          568: {
            slidesPerView: 2,
            // slidesPerGroup: 2,
          },
          1024: {
            slidesPerView: 3,
            // slidesPerGroup: 3,
          },
          1200: {
            slidesPerView: 4,
            // slidesPerGroup: 4,
            // centeredSlides: false,
          },
          1500: {
            slidesPerView: 5,
            // slidesPerGroup: 5,
            // centeredSlides: false,
          },
          1900: {
            slidesPerView: 6,
            // slidesPerGroup: 6,
          },
        }
      });
    }

    // Swiper Block Testimonials
    if ($('.swiper-block-testimonials-slider').length > 0) {
      const swiperBlockTestimonials = new Swiper('.swiper-block-testimonials-slider', {
        spaceBetween: 20,
        autoplay: {
          delay: 25000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        },
        centeredSlides: true,
        loop: true,
        slidesPerView: 1,
        freeMode: true,
        navigation: {
          nextEl: '.swiper-block-testimonials-slider .swiper-button-next',
          prevEl: '.swiper-block-testimonials-slider .swiper-button-prev',
        },
      });
    }

    // Swiper Block Case Studies
    if ($('.swiper-block-latest-posts-slider').length > 0) {
      const swiperBlockLatestPostsSlider = new Swiper('.swiper-block-latest-posts-slider', {
        spaceBetween: 30,
        speed: 800,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        },
        // centeredSlides: true,
        loop: true,
        slidesPerView: 1,
        slidesPerGroup: 1,
        navigation: {
          nextEl: '.swiper-block-latest-posts-slider .swiper-button-next',
          prevEl: '.swiper-block-latest-posts-slider .swiper-button-prev',
        },
        breakpoints: {
          568: {
            slidesPerView: 2,
            // slidesPerGroup: 2,
          },
          1024: {
            slidesPerView: 3,
            // slidesPerGroup: 3,
          }
        }
      });
    }
  }

// Initialize Swipers after DOM is ready and Swiper is loaded
// Always try to initialize, even if Swiper isn't loaded yet
initSwipers();

// If Swiper loads later, initialize when it becomes available
if (typeof Swiper === 'undefined') {
  const checkSwiper = setInterval(function() {
    if (typeof Swiper !== 'undefined') {
      clearInterval(checkSwiper);
      initSwipers();
    }
  }, 100);
  
  // Stop checking after 10 seconds to avoid infinite loop
  setTimeout(function() {
    clearInterval(checkSwiper);
  }, 10000);
}

});